<template>
  <div class="wrapper">
    <Header v-if="isLogin" @logout="isLogin = false" :is-error="isError" />
    <div :class="mainClass">
      <Menu v-if="isLogin && showMenu" />
      <router-view @login-successful="isLogin = true" />
    </div>
    <Footer v-if="isLogin" />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import Menu from "@/components/menu.vue";
export default {
  components: {
    Header,
    Footer,
    Menu,
  },
  name: "App",
  data() {
    return {
      // 共通部分の表示を制御する
      isLogin: false,

      // エラー画面用にメニューの表示を制御する
      showMenu: true,

      // エラー画面かどうか判定
      isError: false,
    };
  },
  computed: {
    // ログイン画面の時のみlogin-mainクラスを使用
    mainClass() {
      if (this.isLogin) {
        return "main";
      } else {
        return "login-main";
      }
    },
  },
  created() {
    this.checkUserInfo();
  },
  watch: {
    /**
     * ログイン以外の各画面に遷移時は共通部分を表示
     * エラー画面に遷移時は共通部分を表示、ヘッダーの一部とメニューを非表示
     */
    $route(to) {
      if (
        to.path === "/search" ||
        to.path === "/register" ||
        to.path === "/registerCount"
      ) {
        this.$data.isLogin = true;
      } else if (to.path === "/error") {
        this.$data.isLogin = true;
        this.isError = true;
        this.$data.showMenu = false;
      } else {
        this.$data.isLogin = false;
      }
    },
  },

  methods: {
    // セッションストレージにユーザー情報がなければログイン画面を表示
    checkUserInfo() {
      const userId = sessionStorage.getItem("SesUserId");
      const authenticationToken = sessionStorage.getItem(
        "SesAuthenticationToken",
      );
      if (!userId || !authenticationToken) {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style>
@import "~@/css/jquery-ui.min.css";
@import "~@/css/perfect-scrollbar.css";
@import "~@/css/layout.css";
</style>
